import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { getSettings } from '@/services/SettingsGetter'

const appElement = document.getElementById('vue-events-plugin')
const blockId = (appElement) ? appElement.getAttribute('data-uid') : null

interface Settings {
	post_types: {
		[key: string]: {
			name: string,
			name_singular: string,
			permalink: string,
			icon: string
		}
	}
	taxonomies: {
		[key: string]: {
			name: string,
			permalink: string,
			post_types: []
		}
	},
	taxonomy_terms: {
		[key: string]: {
			count: number,
			items: object,
			name: string,
		}
	},
}

const settings = await getSettings(blockId) as Settings

if (settings && settings.post_types) {
	// Get route prefix
	const routePrefix = process.env.VUE_APP_RELATIVE_EVENT_BASE_URL || '/'

	const postTypes = Object.keys(settings.post_types)

	// Loop through Post Types and add single event routes
	if (postTypes) {
		const component = () => import(/* webpackChunkName: "SingleEvent" */ '@/views/SingleEvent.vue')
		postTypes.forEach((postTypeSlug:string) => {
			router.addRoute({
				path: routePrefix + settings.post_types[postTypeSlug].permalink + '/:eventId',
				name: 'single-' + settings.post_types[postTypeSlug].permalink,
				component: component
			})
		});
	}
}

if (appElement) {
	createApp(App).provide('settings', settings).use(router).mount(appElement)
} else {
	window.addEventListener(
		'mountVueEventsPlugin',
		async () => {
			createApp(App).provide('settings', settings).use(router).mount('#vue-events-plugin')
		}
	);
}
